// @avantia common-code
import { Policy } from '../types/policyTypes';
import { createMockPolicy, mockSpecifiedItems } from './shared';

export const label = 'Buildings & Contents';

export const policy: Policy = createMockPolicy({
  policyNumber: 'C12/43564300',
  policyDetailsId: '1218112347685',
  forename: 'Albert',
  coverType: 'Buildings & Contents',
  accidentalDamageLevel: { Buildings: 'Basic', Contents: 'Full' },
  specifiedItems: mockSpecifiedItems
});
